<template>
  <div>
    <form v-on:submit.prevent>
      <div class="control has-icons-left has-icons-right">
        <input ref="filterInput" v-bind:value="filter" v-on:input="filter = $event.target.value" type="text" class="input is-rounded" autofocus>
        <span class="icon is-small is-left">
          <i class="mdi mdi-magnify"></i>
        </span>
        <span v-if="filter.length" id="clear-filter-icon" class="icon is-small is-right has-text-grey-lighter">
          <i v-on:click="clearFilter" class="mdi mdi-18px mdi-close-circle poly-cursor-pointer"></i>
        </span>
      </div>
    </form>

    <div v-if="searchResults.genres.length" class="poly-mt-1 poly-mb-1-5">
      <h1 class="is-size-7 is-uppercase">Genres</h1><hr>
      <search-genre-list v-bind:genres="searchResults.genres"/>
    </div>

    <div v-if="searchResults.artists.length" class="poly-mt-1 poly-mb-1-5">
      <h1 class="is-size-7 is-uppercase">Artists</h1><hr>
      <search-artist-list v-bind:artists="searchResults.artists"/>
    </div>

    <div v-if="searchResults.albums.length" class="poly-mt-1 poly-mb-1-5">
      <h1 class="is-size-7 is-uppercase">Albums</h1><hr>
      <search-album-list v-bind:albums="searchResults.albums"/>
    </div>

    <div v-if="searchResults.tracks.length" class="poly-mt-1 poly-mb-1-5">
      <h1 class="is-size-7 is-uppercase">Tracks</h1><hr>
      <search-track-list v-bind:tracks="searchResults.tracks"/>
    </div>
  </div>
</template>

<script>
  import SearchGenreList from '@/components/SearchGenreList'
  import SearchArtistList from '@/components/SearchArtistList'
  import SearchAlbumList from '@/components/SearchAlbumList'
  import SearchTrackList from '@/components/SearchTrackList'

  export default {
    name: 'Search',
    components: {
      SearchGenreList,
      SearchArtistList,
      SearchAlbumList,
      SearchTrackList
    },
    data: function () {
      return {
        filter: this.getFilter() || '',
        searchResults: {
          genres: [],
          artists: [],
          albums: [],
          tracks: []
        }
      }
    },
    mounted () {
      this.focusFilterInput()
    },
    watch: {
      filter(newFilter) {
        this.saveFilter(newFilter)
      }
    },
    methods: {
      getFilter: function () {
        if (typeof localStorage !== 'undefined') {
          return localStorage.getItem('filter')
        }
      },
      saveFilter: function (newFilter) {
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('filter', newFilter)
        }
      },
      clearFilter: function () {
        this.filter = ''
        this.focusFilterInput()
      },
      focusFilterInput: function () {
        this.$refs.filterInput.focus()
      }
    },
    apollo: {
      searchResults: {
        query: require('@/graphql/Search.gql'),
        debounce: 200,
        variables () {
          if (this.filter.length) {
            return { filter: `%${this.filter}%` }
          } else {
            return { filter: '' }
          }
        },
        update (data) {
          return data
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  #clear-filter-icon {
    pointer-events: initial;
  }

  #clear-filter-icon:hover {
    color: $grey-darker !important;
  }
</style>
